import PropTypes from 'prop-types';
import { useContext } from 'react';
import { ADD_DEVICE_SUCCESS } from 'src/common/constants/localizations/devices';
import { LocationAndLocalizationContext } from '../../../providers/LocationAndLocalizationProvider';
import OkDialog from '../../shared/dialog/OkDialog';
import css from './add-device-success-dialog.module.scss';

const AddDeviceSuccessDialog = ({ shouldShow, handleClose }) => {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);

  return (
    <OkDialog
      shouldShow={shouldShow}
      handleClose={handleClose}
      heading={<div className={css.heading}>{getLocalizedText(ADD_DEVICE_SUCCESS)}</div>}
      dataTestId="addDeviceSuccessDialog"
    />
  );
};

AddDeviceSuccessDialog.propTypes = {
  shouldShow: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default AddDeviceSuccessDialog;
